import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Customization",
description: "Learn how to customize the Freon-generated tools by extending or replacing parts of the language environment, including editors, scopers, typers, validators, and other fre-tools.",
tags: [ "customization", "fre-tools", "editor", "typer", "validator", "scoper", "Freon", "DSL development", "TypeScript", "configuration"] ,
modifiedTime: "2025-11-07T18:59:02.342Z",
publishedTime: "2025-11-07T17:20:18.626Z"
    }
  };
};